// Tono di chiamata (ringback) generato con Web Audio: 425 Hz, 1s acceso e
// 4s spento come la linea italiana. Niente file audio da distribuire.
export class Ringback {
  private ctx: AudioContext | null = null;
  private timer: ReturnType<typeof setInterval> | null = null;

  start(): void {
    if (this.ctx) return;
    try {
      this.ctx = new AudioContext();
    } catch {
      return; // senza audio la chiamata funziona lo stesso
    }
    const beep = () => {
      const ctx = this.ctx;
      if (!ctx) return;
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.frequency.value = 425;
      const t = ctx.currentTime;
      gain.gain.setValueAtTime(0, t);
      gain.gain.linearRampToValueAtTime(0.15, t + 0.02);
      gain.gain.setValueAtTime(0.15, t + 0.98);
      gain.gain.linearRampToValueAtTime(0, t + 1);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 1);
    };
    beep();
    this.timer = setInterval(beep, 5000);
  }

  stop(): void {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
    this.ctx?.close().catch(() => {});
    this.ctx = null;
  }
}
